import {get} from "@/lib/axios";

export default {
    async getPopularProducts({pageSize = null}) {
        return get('/products/popular', {pageSize});
    }
}